"use client";

import React from "react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Loader, CircleAlert, Info } from "lucide-react";
function FeaturedProductsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  console.log("FeaturedProducts Diagnostic:", {
    loading,
    error,
    productsCount: products?.length || 0
  });
  if (loading) {
    return <div className="flex flex-col items-center justify-center py-24 space-y-4">
        <Loader className="h-8 w-8 animate-spin text-primary" />
        <p className="text-muted-foreground font-sans animate-pulse">Se încarcă produsele din colecție...</p>
      </div>;
  }
  if (error) {
    return <div className="max-w-2xl mx-auto my-12 p-6 border border-destructive/50 bg-destructive/5 rounded-lg flex items-center gap-4">
        <CircleAlert className="h-6 w-6 text-destructive shrink-0" />
        <div>
          <h3 className="font-semibold text-destructive">Eroare de Diagnostic</h3>
          <p className="text-sm text-muted-foreground">
            Nu am putut prelua produsele de pe server. Eroare: {error}
          </p>
        </div>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="max-w-2xl mx-auto my-12 p-6 border border-primary/20 bg-primary/5 rounded-lg flex items-center gap-4">
        <Info className="h-6 w-6 text-primary shrink-0" />
        <div>
          <h3 className="font-semibold text-foreground">Notificare Sistem</h3>
          <p className="text-sm text-muted-foreground">
            Products provider not initialized or no products found for the current query.
          </p>
        </div>
      </div>;
  }
  return <div data-testid="featured-grid" className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {products.map((product, i) => {
      const isBracelet = product.categories?.some(cat => ['Brățări Individuale', 'Seturi 3 Brățări Unisex', 'Set 5 Bratari Unisex'].includes(cat.name));
      return <Card key={product.id} data-index={i} className="group border-none shadow-2xl hover:-translate-y-2 transition-transform duration-500 overflow-hidden bg-card p-0 rounded-xl">
            <div className="relative overflow-hidden">
              {isBracelet && <div className="absolute top-2 left-2 z-30 bg-primary text-primary-foreground text-[10px] md:text-xs font-bold px-2 py-1 rounded-sm shadow-sm uppercase tracking-wider">
                  Placat cu Aur 18K
                </div>}
              <div className="absolute top-2 right-2 z-30 bg-destructive text-destructive-foreground text-[10px] md:text-xs font-bold px-2 py-1 rounded-sm shadow-sm uppercase tracking-wider">
                50% DISCOUNT
              </div>
              <Link to={product.link} className="block">
                <AspectRatio ratio={4 / 5}>
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full bg-muted flex items-center justify-center">
                      <span className="text-muted-foreground text-sm">Fără imagine</span>
                    </div>}
                </AspectRatio>
              </Link>
              
              <div className="absolute inset-x-6 bottom-6 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0 z-20">
                <AddToCartButton productId={product.id} className="w-full" buttonClassName="w-full bg-background/95 text-foreground hover:bg-background backdrop-blur-md shadow-xl font-sans uppercase tracking-widest text-xs py-6 transition-colors" text="Adaugă Rapid" showQuantity={false} />
              </div>
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
            </div>
            
            <CardContent className="p-6 text-center bg-card relative z-10">
              <Link to={product.link}>
                <h3 className="font-default text-xl font-semibold text-foreground mb-2 line-clamp-1 hover:text-primary transition-colors">
                  {product.title}
                </h3>
              </Link>
              <div className="font-sans text-base text-foreground font-medium">
                {product.discounted_price ? <div className="flex flex-col items-center gap-1">
                    <span className="text-sm text-muted-foreground line-through">
                      {product.price} RON
                    </span>
                    <span className="text-lg font-bold text-destructive">
                      {product.discounted_price} RON
                    </span>
                  </div> : <span>
                    {product.price !== undefined ? `${product.price} RON` : "Preț indisponibil"}
                  </span>}
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function FeaturedProducts() {
  const wp_query = new WP_Query({
    per_page: 20
  });
  return <section id="featured-products" className="py-30 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4">
            Colecția Exclusivă
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" />
        </div>
        
        <EcommerceProductsProvider wp_query={{
        per_page: 20
      }}>
          <FeaturedProductsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}